import type { SVGProps } from "react";
import * as React from "react";

const SvgGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16 12 1 .02v-.04zm-8 0-1-.02v.04zm13 0a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zM2 13h20v-2H2zm9.262-10.326A14.3 14.3 0 0 1 15 12.021l2-.042a16.3 16.3 0 0 0-4.262-10.653zM15 11.98a14.3 14.3 0 0 1-3.738 9.347l1.476 1.348A16.3 16.3 0 0 0 17 12.021zm-2.262 9.347A14.3 14.3 0 0 1 9 11.979l-2 .042a16.3 16.3 0 0 0 4.262 10.653zM9 12.02a14.3 14.3 0 0 1 3.738-9.347l-1.476-1.348A16.3 16.3 0 0 0 7 11.979z"
    />
  </svg>
);
export default SvgGlobe;
